// pages/components/PrivateRoute.tsx (example)
import { Navigate } from "react-router-dom";
import useSWR from "swr";
import api from "../../lib/axios";

const fetcher = (url: string) => api.get(url).then(r => r.data);

export default function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { data, error } = useSWR("/auth/me", fetcher);

  if (!data && !error) return null; // loading spinner if you like

  // not logged in → kick to login
  if (error) return <Navigate to="/" replace />;

  // verified but not done onboarding → force onboarding
  if (data.onboarding_stage !== "complete") {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
